/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as a from "react";
import { useUnstyled as B, classNames as l, uDropDownsBase as i } from "@progress/kendo-react-common";
import { getItemValue as C } from "./utils.mjs";
const b = (e) => {
  const { selected: o, group: t, dataItem: u, virtual: v, groupMode: c, disabled: n, id: f, focused: g, render: r } = e, d = B(), s = d && d.uDropDownsBase, p = (x) => e.onClick(e.index, x), m = /* @__PURE__ */ a.createElement(
    "li",
    {
      id: f,
      role: "option",
      "aria-selected": o,
      "aria-disabled": n ? !0 : void 0,
      className: l(
        i.li({
          c: s,
          selected: o,
          focused: g,
          first: !!t && c === "classic",
          disabled: n
        })
      ),
      onClick: p,
      style: { position: v ? "relative" : "unset" }
    },
    /* @__PURE__ */ a.createElement("span", { className: l(i.itemText({ c: s })) }, C(u, e.textField).toString()),
    t !== void 0 && c === "classic" ? /* @__PURE__ */ a.createElement("div", { className: l(i.itemGroupLabel({ c: s })) }, t) : null
  );
  return r !== void 0 ? r.call(void 0, m, e) : m;
};
export {
  b as default
};
